<template>
    <el-dialog
        v-model="dialogShow"
        width="400px"
        align-center
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape=" false"
        >
        <!-- close,  -->
        <template #header="{ titleId }">
            <div class="dialog_header flexMainXYcenter justify-between">
                <div class="flexMainXYcenter">
                    <img class="prompt_icon flexShrink" src="@/assets/images/layout/prompt_icon.png" alt="">
                    <div class="tit" :id="titleId">储存空间</div>
                </div>
                <img class="close_icon" @click="closeDialogHandle" src="@/assets/images/layout/close_icon.png" alt="">
            </div>
        </template>
        <div class="dialog_body">
            <div class="space_msg mgb8 mgr12">当前容量已满1GB，请清理作品、草稿和已上传文件后继续使用.</div>  
            <div class="space_msg mgr12 flexMainXYcenter"><img class="atten_icon" src="@/assets/images/layout/atten.png" alt=""> 后续版本将升级空间，享更多容量.</div>  
        </div>
        <template #footer>
        <div class="dialog-footer">
            <template v-if="isEditPage">
                <el-button type="primary" class="beauty_btn btn_style" @click="closeDialogHandle">知道了</el-button>
            </template>
            <template v-else>
                <el-button @click="closeDialogHandle" class="normal_btn btn_style">取消</el-button>
                <el-button type="primary" class="beauty_btn btn_style" style="margin-left: 12px;" @click="goManageHanlde">去管理</el-button>
            </template>
        </div>
        </template>
    </el-dialog>
</template>

<script setup>
    import { ref,onMounted } from 'vue'
    const dialogShow = ref(false);
    const props = defineProps(['spaceShow'])
    const emits = defineEmits(['closeDialog','goManage'])
    import { useRoute } from 'vue-router';

    const route = useRoute();

    const isEditPage = ref(false);
    
    const closeDialogHandle = () => {
        emits('closeDialog')
    }

    const goManageHanlde = () => {
        emits('goManage')
    }

    onMounted(()=>{
        dialogShow.value = props.spaceShow
        if(route.path == '/edit'){
            isEditPage.value = true
        }else{
            isEditPage.value = false
        }

    })
</script>